import React from 'react'
import Experts from './Experts'
import ExpertThought from './ExpertThought'
import Action from './Action'

const Resources = () => {
    return (
        <>
            <Experts />
            <ExpertThought />
            <Action />
        </>
    )
}

export default Resources